import { render, staticRenderFns } from "./ToothSVG.vue?vue&type=template&id=57ed27b1&scoped=true&"
import script from "./ToothSVG.vue?vue&type=script&lang=js&"
export * from "./ToothSVG.vue?vue&type=script&lang=js&"
import style0 from "./ToothSVG.vue?vue&type=style&index=0&id=57ed27b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ed27b1",
  null
  
)

export default component.exports